import apiPath from "../config/api-path";
import httpRequest from "../config/http-api";

export default {
  createWorkSheet(data, { success, error }) {
    const {
      workSheet: { create },
    } = apiPath;
    return httpRequest.postRequest(create, data, success, error);
  },
  assignTask(data, { success, error }) {
    const {
      workSheet: { assign },
    } = apiPath;
    return httpRequest.putRequest(assign, data, success, error);
  },
  bulkAssignWorksheet(data, { success, error }) {
    const {
      workSheet: { bulkassign },
    } = apiPath;
    return httpRequest.postRequest(bulkassign, data, success, error);
  },
  getworkSheetById(id, { success, error }) {
    const {
      workSheet: { getById },
    } = apiPath;
    return httpRequest.getRequest(getById(id), success, error);
  },
  getworkSheetByIdByAdmin(id,userId, { success, error }) {
    const {
      workSheet: { getByIdByAdmin },
    } = apiPath;
    return httpRequest.getRequest(getByIdByAdmin(id,userId), success, error);
  },
  getworkSheetByUserId(id, config, { success, error }) {
    const {
      workSheet: { getByUserId },
    } = apiPath;
    return httpRequest.getRequest(getByUserId(id), success, error, config);
  },
  checkTrainingEnrollment({ trainingId, userId }, { success, error }) {
    const {
      workSheet: { config },
    } = apiPath;
    return httpRequest.getRequest(config(trainingId, userId), success, error);
  },
  getProgressById(id, { success, error }) {
    const {
      workSheet: { progress },
    } = apiPath;
    return httpRequest.getRequest(progress(id), success, error);
  },
  getHeatMapDataById(id, { success, error }) {
    const {
      workSheet: { heatmap },
    } = apiPath;
    return httpRequest.getRequest(heatmap(id), success, error);
  },
  getGraphDataById(id, { success, error }) {
    const {
      workSheet: { graph },
    } = apiPath;
    return httpRequest.getRequest(graph(id), success, error);
  },
  getCommentsByWorksheetId(id, { success, error }) {
    const {
      comment: { getByWorkSheetId },
    } = apiPath;
    return httpRequest.getRequest(getByWorkSheetId(id), success, error);
  },
  createCommentForWorksheet(payload, { success, error }) {
    const {
      comment: { create },
    } = apiPath;
    return httpRequest.postRequest(create, payload, success, error);
  },
  setScoreForWorksheet(payload, {success,error}){
    const {
      workSheet: { setScore },
    } = apiPath;
    return httpRequest.postRequest(setScore, payload, success, error);
  },
  getScoreForWorksheet(worksheetId,{success,error}){
    const {
      workSheet: { getScore },
    } = apiPath;
    return httpRequest.getRequest(getScore(worksheetId),success,error);
  },
  getAllScore(trainingId,{success,error}){
    const {
      workSheet: { getallScore },
    } = apiPath;
    return httpRequest.getRequest(getallScore(trainingId),success,error);
  },
  getProgressByTrainingId(trainingId,{success,error}){
    const {
      workSheet: { getProgress },
    } = apiPath;
    return httpRequest.getRequest(getProgress(trainingId),success,error);
  },
  getTrainingScore(config, {success,error}){
    const {
      workSheet: { trainingScore },
    } = apiPath;
    return httpRequest.getRequest(trainingScore, success, error,config);
  },
  getTrainingStatus(config, {success,error}){
    const {
      workSheet: { trainingStatus },
    } = apiPath;
    return httpRequest.getRequest(trainingStatus, success, error,config);
  },
  getTaskScore(adminId,config,{success,error}){
    console.log(adminId,config)
    const {
      workSheet: { taskScore },
    } = apiPath;
    return httpRequest.getRequest(taskScore(adminId), success, error,config);
  }

};
